import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    searchContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-start',
        marginLeft: '20px',
        alignItems: 'center',
    },
    routesContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end',
    },
}));
